// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { createStore } from "redux";

import { authReducer } from "./auth/reducer";

// const rootReducer=combineReducers({
//     auth:authReducer,
//     app:todosReducer
// })

export const store = createStore(
  authReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
